export const BASE_URL = 'https://web.accountsdeck.com/ws/spd/';

let myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("API_TOKEN", "5FHNVICVSEAB7DW602022");

export let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow'
};